export default "__VITE_ASSET__Cra9IPR4__"